<template>
  <div>
    <Ibox :back="true" :titulo="'Usuarios'">
      <b-col cols="12">
        <DataTable
          :loading="loading_tabla"
          :columns="columns"
          :rows="rows">
        <template slot="table-row" slot-scope="props">
          <span v-if="props.column.field == 'inspector' && utils.tienePermiso()">
            <a v-if="props.row.is_i == 1 && props.row.a_i == 0" href="javascript:void(0)" v-on:click="revisarPutSucursalUsuario( props.row, globales.perfil.inspector )">Agregar como inspector</a>
            <a v-else-if="props.row.is_i == 1" href="javascript:void(0)" style="color:red" v-on:click="revisarPutSucursalUsuario( props.row, globales.perfil.inspector )">Quitar como inspector</a>
          </span>
          <span v-if="props.column.field == 'ejecutor' && utils.tienePermiso()">
            <a v-if="props.row.is_e == 1 && props.row.a_e == 0" href="javascript:void(0)" v-on:click="revisarPutSucursalUsuario( props.row, globales.perfil.ejecutor )">Agregar como ejecutor</a>
            <a v-else-if="props.row.is_e == 1" href="javascript:void(0)" style="color:red" v-on:click="revisarPutSucursalUsuario( props.row, globales.perfil.ejecutor )">Quitar como ejecutor</a>
          </span>
          <span v-if="props.column.field == 'administrador_sucursal' && utils.tienePermiso()">
            <a v-if="props.row.is_as == 1 && props.row.a_as == 0" href="javascript:void(0)" v-on:click="revisarPutSucursalUsuario( props.row, globales.perfil.admin_sucursal )">Agregar como administrador de sucursal</a>
            <a v-else-if="props.row.is_as == 1" href="javascript:void(0)" style="color:red" v-on:click="revisarPutSucursalUsuario( props.row, globales.perfil.admin_sucursal )">Quitar como administrador de sucursal</a>
          </span>
          <span v-else>
            {{props.formattedRow[props.column.field]}}
          </span>
        </template>
        </DataTable>
      </b-col>
    </Ibox>
  </div>
</template>

<script>
import { sucursalService, globales } from '@/services';
import { utils } from '@/helpers';

export default {
  name: 'Sucursales', 
  data(){
    return {
      utils,
      globales,
      habilitado:'S',
      sucursal: utils.jd64(this.$route.params.sucursal),
      loading_tabla: true,
      columns:[
        {label: 'Nombre', field: 'nombre_usuario'},
        {label: 'Correo', field: 'correo'},
        {label: 'Inspector', field: 'inspector'},
        {label: 'Ejecutor', field: 'ejecutor'},
        {label: 'Administrador sucursal', field: 'administrador_sucursal'},
      ],
      rows:[],
    }
  },
  mounted () {
    this.cargarDatos();
    this.$store.commit("pagina/setTitulo",'Configuración / Sucursal ' + this.sucursal.desc_sucursal+ ' / Usuarios');
  },
  methods : {
    revisarPutSucursalUsuario(data, id_perfil){
      this.sucursal.id_perfil = id_perfil;
      let agregar_areas = 0;

      if(id_perfil == globales.perfil.ejecutor && data.a_e == 0){
        this.$fire({
            showCancelButton: true,
            html:'¿Desea asociar al ejecutor todas las áreas de la sucursal?',
            confirmButtonText:
              'Si',
            cancelButtonText:
              'No',
        }).then((confirm) => {
          if(confirm.value != null){
            this.putSucursalUsuario(data, id_perfil, 1);
          }else{
            this.putSucursalUsuario(data, id_perfil, 0);
          }
        });
      }else{
        this.putSucursalUsuario(data, id_perfil, agregar_areas);
      }
    },

    putSucursalUsuario(usuario, id_perfil, agregar_areas){
      sucursalService.putSucursalUsuario({
        id_usuario:usuario.id_usuario,
        id_perfil:id_perfil,
        id_sucursal:this.sucursal.id_sucursal,
        agregar_areas:agregar_areas
      }).then(data => {
        if(data.status == 'success'){
          //socket
          this.$socket.emit('prevn', 
            {
              id_usuario:usuario.id_usuario,
              dispatch:'usuario/sincronizar'
            }
          );
          
          this.cargarDatos();
        }
      });
    },
    cargarDatos(){
      sucursalService.getSucursalUsuarios({
        id_cliente:this.$store.state.usuario.id_cliente,
        id_sucursal:this.sucursal.id_sucursal
      }).then(data => {
        this.rows = data.data;

        this.loading_tabla = false;
      });
    },
  }
}
</script>

<style scoped>

</style>
